// src/partners/referralApi.ts
import { apiClient } from "@maat/api-base";
var referralApi = {
  /** Landing-page link info; also sets/refreshes the attribution cookie. */
  linkInfo: async (code) => {
    return apiClient.get(`/main/api/referral/links/${encodeURIComponent(code)}`);
  },
  /** Landing-page fingerprint enrichment (probabilistic matching, §5.4). */
  sendFingerprint: async (data) => {
    await apiClient.post("/main/api/referral/fingerprint", data);
  },
  /** App first-launch match — display-only; attribution recomputes at signup. */
  resolve: async (data) => {
    return apiClient.post("/main/api/referral/resolve", data);
  }
};

export {
  referralApi
};
